import React from "react";
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { X } from "lucide-react";

interface VideoPlayerDialogProps {
	isOpen: boolean;
	onClose: () => void;
	videoUrl: string;
	title: string;
}

const VideoPlayerDialog: React.FC<VideoPlayerDialogProps> = ({
	isOpen,
	onClose,
	videoUrl,
	title,
}) => {
	return (
		<Dialog open={isOpen} onOpenChange={onClose}>
			<DialogContent className="max-w-4xl w-full p-0 [&>button]:hidden" >
				<DialogHeader className="px-6 py-4 borde m-0 max-h-16">
					<div className="flex items-center justify-between h-10">
						<DialogTitle className="text-lg font-semibold">
							{title}
						</DialogTitle>
						<Button
							variant="ghost"
							size="sm"
							onClick={onClose}
							className="h-8 w-8 p-0"
						>
							<X className="h-4 w-4" />
						</Button>
					</div>
				</DialogHeader>
				
				<div className="flex-1 p-0  h-full">
					<div className=" rounded-b-lg overflow-hidden bg-black">
						<video
							src={videoUrl}
							controls
							className="w-full h-full object-contain"
							preload="metadata"
							controlsList="nodownload"
						>
							Your browser does not support the video tag.
						</video>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	);
};

export default VideoPlayerDialog;
